import React from "react";
import tensoBlock from "../assets/images/maqueta/tenso-nft/bloque-h.png";
import viguetaNft from "../assets/images/maqueta/tenso-nft/m-producto.png";
import tensoBlockNovedadBackground from "../assets/images/maqueta/tenso-nft/blockNFT.png"
import backgrondDetalleProd2 from "../assets/images/maqueta/tenso-nft/backgrondDetalleProd2.jpg"
import viguetaNovedadBackground from "../assets/images/maqueta/tenso-nft/viguNFT.jpg"
import { useNavigate } from 'react-router-dom'

const NFTcards = [
  {
    title: "NFTBlock",
    background_card: `${tensoBlockNovedadBackground}`,
    img: `${tensoBlock}`,
    price_eth: "0.15",
    price_usd: "251",
  },
  {
    title: "NFTViguT21",
    background_card: `${viguetaNovedadBackground}`,
    img: `${viguetaNft}`,
    price_eth: "0.12",
    price_usd: "231",
  },
];

const TensoliteNFT = () => {

  const navigate = useNavigate()
  
  const VerPrducto = (e) => {
    // console.log(e.target.id)
    navigate("/tensoliteNFT/vista-producto", { replace: true , state: {producto: `${e.target.id}`}}); // esta es la logica para abrir galeria y pasar por parametro 'state' el prod que se va a mostrar
  }
  return (
    <>
      <div className="image_background-container-nft overlay">
        <section className="hero">
          <div className="title">
            <h1>
              Tensolite <b>NFT</b>
            </h1>
            <h3>welcome to innovation</h3>
          </div>
          <div className="reel_novedades">
            <div
              className="card_presentacion"
              style={{ backgroundImage: `url(${backgrondDetalleProd2})` }}
            >
              <figure className="card_presentacion-tensoblock--container">
                <img src={tensoBlock} alt="tensoblock-presentacion" />
                <figcaption className="image-foot--container">
                  <div className="timer contador-dias">
                    <h3>06</h3>
                    <p>days</p>
                  </div>
                  <h3>:</h3>
                  <div className="timer contador-horas">
                    <h3>19</h3>
                    <p>hrs</p>
                  </div>
                  <h3>:</h3>
                  <div className="timer contador-minutos">
                    <h3>24</h3>
                    <p>min</p>
                  </div>
                  <h3>:</h3>
                  <div className="timer contador-segundos">
                    <h3>16</h3>
                    <p>sec</p>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
        </section>
      </div>
      <div className="image_background-container-nft overlay"></div>
      <section className="w-100  seccion_que-es">
        <div className="text--container">
          <h2>¿Que son los NFT de tensolite?</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. <br />
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </p>
        </div>
        <div className="seccion_que-es--imagen">
          <div
            className="card_presentacion"
            style={{ backgroundImage: `url(${viguetaNovedadBackground})` }}
          >
            <figure>
              <div className="price-container">
                <h4 className="eth">0.15 ETH</h4>
                <h4 className="usd">~ u$s 251</h4>
              </div>
              <img src={viguetaNft} alt="" />
              <figcaption className="image-foot--container">
                <label id="NFTViguT21" onClick={VerPrducto} >Ver presentación</label>
                {/* <label>Comprar</label> */}
              </figcaption>
            </figure>
          </div>
        </div>
      </section>
      <div className="image_background-container-nft overlay"></div>
      <section className="marketplace">
        <div className="marketplace-text">
          <h2>Marketplace</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
          </p>
        </div>
        <div className="productos_container">
        {
          NFTcards.map((card, index) => (
            <div key={index} className="box">
              <div className="imgBx">
                <img src={card.background_card} alt={card.title} />
              </div>
              <div className="content">
                <div>
                  <h2>{card.title}</h2>
                 <p>{card.price_eth} ETH ~ {card.price_usd}</p>
                 <button id={card.title} onClick={VerPrducto}>Ver producto</button>
                </div>
              </div>
            </div>
          ))
        }
        </div>
      </section>
      <div className="image_background-container-nft overlay"></div>
    </>
  );
};

export default TensoliteNFT;
